import { render, staticRenderFns } from "./TemlikBilgisininBildirilmesiTalepEvrakForm.vue?vue&type=template&id=5e683c49"
import script from "./TemlikBilgisininBildirilmesiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./TemlikBilgisininBildirilmesiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports